<template>
  <!-- 发布成功 -->
  <div class="createSuccess">
     <mt-header title="发布成功">
      <mt-button slot="right" @click= 'goToJob()'>完成</mt-button>
    </mt-header>
    <div class="content">
      <h1><icon name='check-circle'></icon>发布成功</h1>
      <p>项目发送成功!请等待审核，平台项目管家会在工作日一小时内和您电话联系，请您注意接听。</p>
    </div>
    <div class="btns">
      <button type="button" @click= 'goToJob()'>知道了</button>
    </div>
  </div>
</template>

<script>
import bus from '../utiles/bus'
export default {
  name: 'createSuccess',
  methods: {
    goToJob: function () {
      bus.$emit('routerBus', 'btnFive')
      this.$router.push({path: '/myJobs'})
    }
  }
}
</script>

<style scoped>
.content{
  margin-top: 40%;
}
.content h1{
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}
.content h1 .fa-icon{
  color: #108ee9;
  transform: scale(1.5);
  margin-right:10px;
}
.content p{
  font-size: 14px;
  text-indent: 24px;
  width: 80%;
  margin: 24px auto 0;
}
.btns{
  margin-top: 20%;
  text-align: center;
}
.btns button{
  width: 90%;
  font-size: 14px;
  color: #fff;
  background-color: #108ee9;
  height: 38px;
  border: none;
  outline:none;
  border-radius:20px;
  -webkit-border-radius:20px;
  -moz-border-radius:20px;
}
</style>


// WEBPACK FOOTER //
// createSuccess.vue?c23d85a4